import { ChangeEvent } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import { usePrefillableValue } from '../../hooks/usePrefillableValue';
import { MultipleLineTextViewModel } from '../../types/multipleLineText';
import JabraLegend from '../Shared/JabraLegend';
import JabraTextarea from '../Shared/JabraTextarea';

const MultipleLineText: React.FC<ValueFieldProps<MultipleLineTextViewModel>> = (props) => {
  const { field, isValid } = props;
  const { id, name } = field.valueField;
  const { labelCssClass, placeholderText, required, rows, showLegend, title } = field.model;
  const [value, setValue] = usePrefillableValue(
    field.model.name,
    props.value,
    props.onChange,
    field.valueField.name
  );
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const Label = props.labelComponent;

  const onChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event?.target?.value;
    setValue(newValue);
    props.onChange(name, newValue, isValid, []);
  };

  return (
    <>
      {!!Label && <Label {...props} />}
      <JabraTextarea
        id={id}
        name={name}
        jssMetadata={props}
        value={value}
        placeholder={placeholderText}
        required={required}
        rows={rows}
        onChange={onChange}
      />
      {showLegend && !!title && (
        <JabraLegend className={labelCssClass} dangerouslySetInnerHTML={{ __html: title }} />
      )}
      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};
export default MultipleLineText;
